import { render, staticRenderFns } from "./CameraMenu.vue?vue&type=template&id=5cf3a9b8"
import script from "./CameraMenu.vue?vue&type=script&lang=js"
export * from "./CameraMenu.vue?vue&type=script&lang=js"
import style0 from "./CameraMenu.vue?vue&type=style&index=0&id=5cf3a9b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VIcon,VList,VListItem,VListItemTitle,VMenu,VSwitch})
